import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../common/icons/Icon';
import moment from 'moment';

class EpisodeDescription extends PureComponent {
  static propTypes = {
    showId: PropTypes.number.isRequired,
    episodeId: PropTypes.number.isRequired,
    episodeIndex: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    duration: PropTypes.number.isRequired,
    progress: PropTypes.number.isRequired,
    complete: PropTypes.bool,
    image: PropTypes.string,
    favoriteIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onFavoriteToggle: PropTypes.func,
  };

  static defaultProps = {
    image: 'https://d27vybgvtr1dba.cloudfront.net/placeholder.jpg',
    progress: null,
  };

  render() {
    const {
      description,
      duration,
      showId,
      episodeId,
      episodeIndex,
      progress,
      image,
      complete,
      name,
      favoriteIcon,
    } = this.props;

    return (
      <Link to={`/subscription/tv/${showId}/${episodeId}?autoplay`} className="episode__card">
        <div className="episode-card__image" style={{ backgroundImage: `url(${image})` }}>
          {complete ? <div className="episode__card__watched">Watched</div> : null}
          <Icon icon="PlayCircle" />
          <div className="episode__card-info">
            <div className="episode__card-info__top">
              <span>Episode {episodeIndex}</span>
              <span>{Math.round(moment.duration(1000 * duration).asMinutes())}m</span>
            </div>
            <div className="episode__card-info__progress__bar">
              <span
                className="episode__card-info__progress"
                style={{ width: `${Math.round(100 * progress / duration)}%` }}
              />
            </div>
          </div>
        </div>
        <div className="episode-header">
          <h4>{name}</h4>
          <div onClick={e => this.props.onFavoriteToggle(e, episodeId)}>{favoriteIcon}</div>
        </div>
        <p>{description}</p>
      </Link>
    );
  }
}

export default EpisodeDescription;



// WEBPACK FOOTER //
// ./src/subscription/tv/common/EpisodeDescription.js